// @ts-nocheck
import "@store/Framework/Store";
import foundationReducer, { FoundationActions } from "@store/Framework/Store/Foundation/FoundationReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import bunzlReducer, { BunzlActions } from "@store/Framework/Store/Bunzl/BunzlReducer";

export type BunzlAnyAction = BunzlActions;
export type FoundationAnyAction = FoundationActions;

(reducers as any).bunzl = bunzlReducer;
(reducers as any).foundation = foundationReducer;
